import styled from 'styled-components';

export const SettingsWrapper = styled.div`
  padding: 24px 6%;
  margin-bottom: 24px;
`;
